import { Box, IconButton } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const DashboardContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
}));

const ContentContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  flex: 1, // Take up all available space between header and footer
  width: '100%',
  minHeight: 0, // Prevents overflow
}));

const RouteContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1, // Grow to fill space
  minHeight: 0,
  overflow: 'auto',
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
    : alpha(theme.palette.background.default, 1),
}));

//Persistent Left Drawer Components
const drawerWidthMin = 172;
const drawerWidthMax = 320;
const drawerWidthClosed = 100;

const DrawerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  flexGrow: 0,
  height: '100%',
  minWidth: open ? drawerWidthMin : drawerWidthClosed,
  maxWidth: open ? drawerWidthMax : drawerWidthClosed,
  width: open ? 'max-content' : drawerWidthClosed,
  transition: theme.transitions.create(['min-width', 'max-width', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: open
      ? theme.transitions.duration.enteringScreen
      : theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  boxSizing: 'border-box',
}));

const ToggleButton = styled(IconButton)(() => ({
  display: 'flex',
  backgroundColor: 'transparent !important', // This overrides the root background'
  '&:hover svg': {
    color: '#154F85 !important', // Icon color on hover
  }, // Ensure the icon uses the parent's color by default
  '& svg': {
    color: 'inherit',
    transition: 'color 0.2s',
  },
}));

export {
  DashboardContainer,
  ContentContainer,
  RouteContainer,
  DrawerBox,
  ToggleButton,
};
